export const en = {
    from: 'from',
    per_night: 'per night',
    office: 'Office',
};
